import { render, staticRenderFns } from "./CardsContract.vue?vue&type=template&id=496a34b8&"
import script from "./CardsContract.vue?vue&type=script&lang=js&"
export * from "./CardsContract.vue?vue&type=script&lang=js&"
import style0 from "./CardsContract.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CardsContract.vue"
export default component.exports